import {
  AppstoreOutlined,
  ApartmentOutlined,
  GlobalOutlined
} from '@ant-design/icons';

// 图标组件映射配置
export const iconComponents = {
  AppstoreOutlined,
  ApartmentOutlined,
  GlobalOutlined
} as const;

// 标签页配置类型
export interface TabConfig {
  key: string;
  label: string;
  icon: keyof typeof iconComponents;
}

// 标签页配置常量
export const TAB_CONFIGS = {
  OVERVIEW: {
    key: 'overview',
    label: '概览',
    icon: 'AppstoreOutlined' as const
  },
  FLOOR_PLAN: {
    key: 'floorplan',
    label: '平面图',
    icon: 'ApartmentOutlined' as const
  },
  THREE_D: {
    key: '3d',
    label: '3D视图',
    icon: 'GlobalOutlined' as const
  },
  MAP: {
    key: 'map',
    label: '地图',
    icon: 'GlobalOutlined' as const
  }
} as const;

// 默认标签页
export const DEFAULT_TAB = TAB_CONFIGS.OVERVIEW.key;
